import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styles from '../../styles/common/FAQModal.module.css';
import modalStyles from '../../styles/common/Modal.module.css';

interface FAQModalProps {
    show: boolean;
    onHide: () => void;
}

const FAQModal: React.FC<FAQModalProps> = ({
    show,
    onHide,
}) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            size="lg"
            scrollable={true}
            className={styles.faqModal}
            contentClassName={styles.scaleIn}
            animation={false}
        >
            <Modal.Header closeButton>
                <Modal.Title as="h3" className={modalStyles.modalTitle}>
                    Preguntas Frecuentes
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="faq-content">
                    <h5>1. ¿Por qué elegir elPaket?</h5>
                    <p>Ofrecemos tarifas transparentes, tracking real 24/7, seguro y cobertura en más de 300 destinos.</p>

                    <h5>2. ¿Qué es el servicio puerta a puerta?</h5>
                    <p>Es un método donde recogemos (o recibimos) tu paquete en USA y lo entregamos directamente en la dirección del destinatario en Latinoamérica. Nos encargamos de toda la logística y aduana.</p>

                    <h5>3. ¿Cómo se calculan los costos de envío?</h5>
                    <p>
                        El costo final depende del peso y del espacio que ocupe tu paquete en el transporte. Siempre se cobrará el valor más alto entre el peso físico (báscula) y el peso volumétrico (dimensiones).
                        <br /><br />
                        No te preocupes por hacer cuentas: puedes obtener el costo estimado de forma automática usando nuestra <Link to="/calculator" onClick={onHide}>Calculadora de Envíos en línea</Link>. ¡Solo necesitas ingresar las medidas de tu paquete!
                    </p>

                    <h5>4. ¿Existen costos ocultos?</h5>
                    <p>
                        No. El precio incluye transporte y entrega. Cargos extra solo aplican por: reempaque solicitado o impuestos en artículos de alto valor (laptops, etc). Los costos de envío están sujetos a variaciones. Si el peso, las medidas o el valor declarado indicados originalmente son incorrectos, se aplicará un reajuste en el precio final de su orden tras la auditoría física de la carga.
                    </p>

                    <h5>5. ¿Cuánto tarda en llegar?</h5>
                    <p>Aéreo: 7-15 días hábiles. Marítimo: 4-6 semanas. Puede variar por aduanas o temporada.</p>

                    <h5>6. ¿Puedo rastrear mi paquete?</h5>
                    <p>Sí, en tiempo real ingresando tu número de guía en nuestra página de Rastreo. Recibirás notificaciones por email.</p>

                    <h5>7. Artículos Permitidos</h5>
                    <p>Ropa, electrónicos, juguetes, comida seca, medicinas (con receta), repuestos, herramientas.</p>

                    <h5>8. Artículos PROHIBIDOS 🚫</h5>
                    <p>Armas, drogas, dinero, joyas, carnes/embutidos, aerosoles, material inflamable o pornográfico.</p>

                    <h5>9. ¿Puedo enviar medicinas?</h5>
                    <p>Sí, cantidad personal (máx 3 meses) con receta médica copia adjunta.</p>

                    <h5>10. ¿Qué documentos necesito?</h5>
                    <p>Remitente: ID válido. Destinatario: Cédula, dirección completa y teléfono.</p>

                    <h5>11. ¿Pago impuestos?</h5>
                    <p>
                        El pago de impuestos varía según el país de destino y el valor de la mercancía. Para consultar el detalle y la tabla completa de aranceles e impuestos por país, por favor visita nuestra <Link to="/preguntas-frecuentes" onClick={onHide}>Página de Preguntas Frecuentes</Link>.
                    </p>

                    <h5>12. ¿Ofrecen seguro?</h5>
                    <p>Si, Ponemos a su disposición un servicio de seguro de mercancía cuya tarifa y nivel de cobertura se determinan en proporción directa al valor declarado de los Bienes.</p>

                    <h5>13. ¿Qué hago si se pierde?</h5>
                    <p>
                        En Caso de Extravío o Pérdida de Envíos se iniciará de forma automática un proceso de auditoría e investigación interna. Este procedimiento tiene un tiempo estimado de resolución de 7 a 15 días hábiles. Una vez concluido el análisis y determinada la pérdida definitiva, se procederá con el reembolso del 100% del valor declarado por el cliente al momento de contratar el servicio.
                    </p>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="primary"
                    onClick={onHide}
                    className={modalStyles.closeBtn}
                >
                    Aceptar y Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default FAQModal;
